import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19f7cdb9")

_pushScopeId("data-v-19f7cdb9")
const _hoisted_1 = { class: "py-3 pr-6 detail-refund-config" }
const _hoisted_2 = { class: "remarks-table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: "Refund Configuration",
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetailData
  }, {
    data: _withId(() => [
      _createVNode(_component_DataWrapper, {
        label: "ID Configurable",
        value: _ctx.detailData.configurablePriceId
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Nama Harga",
        value: _ctx.detailData.configurablePriceName
      }, null, 8, ["value"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_TableV2, {
          data: _ctx.detailData.configurableRefund,
          columns: _ctx.getColumns(),
          pagination: _ctx.pagination,
          hidePagination: ""
        }, {
          "expand-row": _withId(({item}) => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_TableV2, {
                isStickyHeader: false,
                borderBottom: false,
                data: item.remarks,
                columns: _ctx.getColumns(item.remarks[0]),
                pagination: _ctx.pagination,
                hidePagination: ""
              }, null, 8, ["data", "columns", "pagination"])
            ])
          ]),
          _: 1
        }, 8, ["data", "columns", "pagination"])
      ])
    ]),
    "sub-data": _withId(() => [
      _createVNode(_component_DataWrapper, { label: "Status Harga" }, {
        default: _withId(() => [
          _createVNode(_component_Chips, {
            class: "mt-2",
            label: _ctx.detailData.configurablePriceStatus,
            textColor: 
            _ctx.detailData.configurablePriceStatus.toLowerCase() === 'active'
              ? 'green-lp-200'
              : 'red-lp-200'
          ,
            color: 
            _ctx.detailData.configurablePriceStatus.toLowerCase() === 'active'
              ? 'green-lp-300'
              : 'red-300'
          ,
            rounded: ""
          }, null, 8, ["label", "textColor", "color"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Dibuat",
        value: _ctx.formatDate(_ctx.detailData.configurablePriceCreatedAt),
        caption: _ctx.detailData.configurablePriceCreatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Diubah",
        value: _ctx.formatDate(_ctx.detailData.configurablePriceUpdatedAt),
        caption: _ctx.detailData.configurablePriceUpdatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_LpButton, {
        title: "Ubah",
        onClick: _ctx.goToEdit,
        textColor: "white"
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"]))
})